<p class="p"><strong>Questions on billing & insurance?</strong></p>
<p class="p2">Get information on <a [href]="link" [target]="target">billing and insurance</a>.</p>
